module.exports = __webpack_public_path__ + "static/img/item-l_j_lemonade.28cbd28.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/item-l_j_lemonade.png
// module id = FvTG
// module chunks = 1